module.exports = __webpack_public_path__ + "img/box9-19.b50682f7.png";